import React from "react"
import { Link } from "gatsby"
import logo from "../../../static/logo/logo.svg"
import styled from "styled-components"

const LogoWrapper = styled.header`
  width: 100%;
  margin: 60px auto 20px auto;
  text-align: center;
  z-index: 999;
  .siteLogo {
    max-height: 38px;
  }

  @media only screen and (min-width: 768px) {
    .siteLogo {
      max-height: 44px;
    }
  }
  @media only screen and (max-width: 320px) {
    .siteLogo {
      max-height: 32px;
    }
  }
`

const Logo = () => {
  return (
    <LogoWrapper>
      <div className="gb--container">
        <Link to="/" aria-label="Websitecafe Learning">
          <img
            className="siteLogo"
            src={logo}
            width="175"
            height="44"
            alt="Websitecafe"
          />
        </Link>
      </div>
    </LogoWrapper>
  )
}

export default Logo
